import { useQuery } from '@tanstack/react-query';
import { publicGet } from '@/lib/api/publicClient';
import { publicBookingEndpoints } from '@/lib/api/endpoints';
import type { AvailabilityResponse } from '@/types/onlineBooking';

export const availabilityKeys = {
  all: () => ['public', 'availability'] as const,
  byService: (key: string, serviceId: string, month: string, zip: string) =>
    [...availabilityKeys.all(), key, serviceId, month, zip] as const,
};

export function useAvailability(key: string, serviceId: string, month: string, zip: string) {
  return useQuery<AvailabilityResponse>({
    queryKey: availabilityKeys.byService(key, serviceId, month, zip),
    queryFn: () =>
      publicGet<AvailabilityResponse>(publicBookingEndpoints.availability(key, serviceId), {
        month,
        zip,
      }),
    enabled: !!key && !!serviceId && !!month && !!zip,
    staleTime: 60_000,
  });
}
